export default {
  // Lucky Draw Config
  "luckydrawConfig.add": "Add",
  "luckydrawConfig.details": "Details",
  "luckydrawConfig.edit": "Edit",
  "luckydrawConfig.delete": "Delete",
  "luckydrawConfig.delete.confirm.title": "Delete Configuration",
  "luckydrawConfig.delete.confirm.content": "Are you sure you want to delete this configuration?",
  "luckydrawConfig.delete.confirm.okText": "Confirm",
  "luckydrawConfig.delete.confirm.cancelText": "Cancel",
  "luckydrawConfig.modal.title": "Lucky Draw Configuration",
  "luckydrawConfig.operation.success": "Operation successful",
  
  // Table Headers
  "luckydrawConfig.thead.id": "ID",
  "luckydrawConfig.thead.documentId": "Document ID",
  "luckydrawConfig.thead.timeOfArrival": "Time of Arrival",
  "luckydrawConfig.thead.hoursUntilExpiration": "Hours Until Expiration",
  "luckydrawConfig.thead.drawBoxAmounts": "Draw Box Amounts",
  "luckydrawConfig.thead.getDrawsAmounts": "Get Draws Amounts",
  "luckydrawConfig.thead.bindSite": "Bind Site",
  "luckydrawConfig.thead.configName": "Config Name",
  "luckydrawConfig.thead.itemName": "Item Name",
  "luckydrawConfig.thead.itemId": "Item ID",
  "luckydrawConfig.thead.drawType": "Draw Type",
  "luckydrawConfig.thead.sort": "Sort",
  "luckydrawConfig.thead.status": "Status",
  "luckydrawConfig.thead.active": "Active",
  "luckydrawConfig.thead.remark": "Remark",
  "luckydrawConfig.thead.content": "Content",
  "luckydrawConfig.thead.description": "Description",
  "luckydrawConfig.thead.title": "Title",
  "luckydrawConfig.thead.createdAt": "Created At",
  "luckydrawConfig.thead.updatedAt": "Updated At",
  "luckydrawConfig.thead.publishedAt": "Published At",
  "luckydrawConfig.thead.locale": "Locale",
  "luckydrawConfig.thead.createdBy": "Created By",
  "luckydrawConfig.thead.updatedBy": "Updated By",
  "luckydrawConfig.thead.localizations": "Localizations",
  "luckydrawConfig.thead.action": "Action",
  
  // Form
  "luckydrawConfig.form.configName.required": "Please enter config name",
  
  // Status
  "luckydrawConfig.status.active": "Active",
  "luckydrawConfig.status.inactive": "Inactive",
};